import type { IComponent } from "@Components/Component";
import { Component } from "@Components/Component";
import type { IMultipleSelect, IMultipleSelectOption } from "@Components/MultipleSelect";
import { MultipleSelect } from "@Components/MultipleSelect";

import type {
    IAdditionalService,
    IShoppingMallsFiltersSearchServices,
} from "./ShoppingMallsFiltersSearchServices";
import { ShoppingMallsFiltersSearchServices } from "./ShoppingMallsFiltersSearchServices";

import * as css from "./ShoppingMallsFilters.module.css";

export interface IShoppingMallsFiltersSearch extends IComponent {
    searchServicesTitle?: string;
    searchBrandsTitle?: string;
    searchServices?: IShoppingMallsFiltersSearchServices;
    additionalServiceList?: IAdditionalService[];
    selectedServicesList?: IAdditionalService[];
    searchBrands?: IMultipleSelect;
    selectedBrandsList?: IMultipleSelectOption[];
    onServiceChange?: (services: IAdditionalService[]) => void;
    onBrandChange?: (brandsList: IMultipleSelectOption[]) => void;
}

export class ShoppingMallsFiltersSearch extends Component<IShoppingMallsFiltersSearch, {}> {
    private get searchServices(): JSX.Element {
        if (!this.props.searchServices) {
            return null;
        }

        const searchServices = { ...this.props.searchServices };
        searchServices.onFilterChange = this.onServiceClick;
        searchServices.selectedServicesList = this.props.selectedServicesList.map((s) => s.value);
        searchServices.additionalServicesList = this.props.additionalServiceList;

        return (
            <div>
                <h3>{this.props.searchServicesTitle}</h3>
                <ShoppingMallsFiltersSearchServices {...searchServices} />
            </div>
        );
    }

    private get brandsSearch(): JSX.Element {
        if (!this.props.searchBrands) {
            return null;
        }

        const searchBrands = { ...this.props.searchBrands };
        searchBrands.onChange = this.onBrandChange;
        searchBrands.selectedValues = this.props.selectedBrandsList;

        return (
            <div>
                <h3>{this.props.searchBrandsTitle}</h3>
                <MultipleSelect {...searchBrands} />
            </div>
        );
    }

    public static readonly defaultProps: IShoppingMallsFiltersSearch = {
        searchServicesTitle: null,
        searchBrandsTitle: null,
        searchServices: null,
        additionalServiceList: [],
        selectedServicesList: [],
        searchBrands: null,
        selectedBrandsList: [],
        onServiceChange: null,
        onBrandChange: null,
    };

    constructor(props: IShoppingMallsFiltersSearch) {
        super(props);

        this.onServiceClick = this.onServiceClick.bind(this);
        this.onBrandChange = this.onBrandChange.bind(this);
    }

    public renderSearch() {
        return (
            <div className={css.shoppingMallsFiltersSearch}>
                {this.searchServices}
                {this.brandsSearch}
            </div>
        );
    }

    public render() {
        return (
            <div {...this.rootDefaultAttributes(css.shoppingMallsFiltersSearchComponent)}>
                {this.renderSearch()}
            </div>
        );
    }

    private onServiceClick(service: string): boolean {
        const servicesList = this.props.selectedServicesList.filter((s) => s.value === service);

        const selectedServicesList = this.props.selectedServicesList.slice();

        if (servicesList.length > 0) {
            const index = selectedServicesList.indexOf(servicesList[0]);
            selectedServicesList.splice(index, 1);
        } else {
            const selected = this.props.additionalServiceList.filter((s) => s.value === service);
            if (selected.length > 0) {
                selectedServicesList.push(selected[0]);
            }
        }
        if (this.props.onServiceChange) {
            return this.props.onServiceChange.call(this, selectedServicesList);
        }

        return false;
    }

    private onBrandChange(selectedBrands: IMultipleSelectOption[]): void {
        if (this.props.onBrandChange) {
            this.props.onBrandChange.call(this, selectedBrands);
        }
    }
}
